/** First viewport width (px) treated as tablet / desktop. Below this is mobile. */
export const TABLET_MIN_WIDTH_PX = 960;

/** Last viewport width (px) still treated as mobile. */
export const MOBILE_MAX_WIDTH_PX = TABLET_MIN_WIDTH_PX - 1;

/** CSS media query matching mobile-only viewports. */
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH_PX}px)`;
